import illustration1 from "../../assests/illustration1.svg";
import "./LandingPage.css";
const LandingPage = () => {
 return (
  <div className="main-content">
   <main className="max-width">
    <section className="landing-page">
     <article className="texts-container">
      <h2 className="bold" style={{ color: "rgb(1, 1, 34)" }}>
       Creative Digital Agency
      </h2>
      <p className="semi-bold">
       Lorem ipsum dolor sit, amet consectetur adipisicing elit. Corrupti quam
       architecto aliquam omnis nam rerum consequuntur illo assumenda dolor
       incidunt!
      </p>

      <div className="btn-container">
       <button>What we do</button>
       <button>See Pricing</button>
      </div>
     </article>

     <article className="landing-page-image">
      <img src={illustration1} alt="illustration" />
     </article>
    </section>
   </main>
  </div>
 );
};

export default LandingPage;
